/**
 * 后台管理页在移动端允许双指缩放/缩小，便于查看未做响应式适配的桌面布局。
 * 进入 /admin 时放宽 viewport；离开时恢复站点默认（禁止缩放）。
 */

const VIEWPORT_SELECTOR = 'meta[name="viewport"]'

/** 与 index.html 默认一致 */
const DEFAULT_VIEWPORT =
  'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover'

/** 按较宽逻辑宽度渲染，允许双指缩放与缩小 */
const ADMIN_VIEWPORT =
  'width=1280, initial-scale=0.32, minimum-scale=0.15, maximum-scale=4.0, user-scalable=yes, viewport-fit=cover'

function getViewportMeta() {
  return document.querySelector(VIEWPORT_SELECTOR)
}

function ensureViewportMeta() {
  let meta = getViewportMeta()
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('name', 'viewport')
    document.head.appendChild(meta)
  }
  return meta
}

export function isAdminRoutePath(path) {
  return typeof path === 'string' && (path === '/admin' || path.startsWith('/admin/') || path.startsWith('/admin-test'))
}

export function applyAdminMobileViewport() {
  const meta = ensureViewportMeta()
  if (!meta.dataset.defaultViewportContent) {
    meta.dataset.defaultViewportContent = meta.getAttribute('content') || DEFAULT_VIEWPORT
  }
  meta.setAttribute('content', ADMIN_VIEWPORT)
  document.documentElement.classList.add('admin-mobile-zoom-enabled')
}

export function restoreDefaultViewport() {
  const meta = getViewportMeta()
  if (!meta) return
  const restored = meta.dataset.defaultViewportContent || DEFAULT_VIEWPORT
  meta.setAttribute('content', restored)
  delete meta.dataset.defaultViewportContent
  document.documentElement.classList.remove('admin-mobile-zoom-enabled')
}
